var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.932,
    height: 16.734,
    viewBox: "0 0 17.932 16.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-dots",
    transform: "translate(0 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M38.241,85.121A1.121,1.121,0,1,1,37.121,84,1.121,1.121,0,0,1,38.241,85.121Zm4.483,0A1.121,1.121,0,1,1,41.6,84,1.121,1.121,0,0,1,42.724,85.121Zm3.362,1.121a1.121,1.121,0,1,0-1.121-1.121A1.121,1.121,0,0,0,46.087,86.241Z",
    transform: "translate(-32.638 -77.276)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M2.426,28.59l.022,0a15.3,15.3,0,0,0,3.887-1.238,10.154,10.154,0,0,0,2.63.343c4.951,0,8.966-3.512,8.966-7.845S13.917,12,8.966,12,0,15.512,0,19.845A7.28,7.28,0,0,0,2.208,25a11.7,11.7,0,0,1-.587,2.6l0,.012q-.125.361-.273.714a.292.292,0,0,0,.306.406q.389-.064.777-.14Zm.9-3.483a1.121,1.121,0,0,0-.322-.9,6.164,6.164,0,0,1-1.881-4.364c0-3.577,3.367-6.724,7.845-6.724s7.845,3.147,7.845,6.724-3.367,6.724-7.845,6.724a9.033,9.033,0,0,1-2.34-.3,1.121,1.121,0,0,0-.8.083,13.258,13.258,0,0,1-2.952,1,12.294,12.294,0,0,0,.446-2.241Z",
    transform: "translate(0 -12)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.5b815be35a859105015ee7f064372b97.svg";
export { ForwardRef as ReactComponent };